import { focusItems } from '@/mocks/homeNews';
import SectionHeading from './SectionHeading';

export default function FocusGrid() {
  return (
    <section id="focus" className="w-full bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          kicker="Weekly Focus"
          title="本周焦点大图"
          desc="挑出这一周热度最高、进展最密集的三条线索，用封面级大图呈现，点开就能顺着看下去。"
          action={
            <a
              href="#latest"
              className="inline-flex items-center gap-1.5 text-[13px] font-medium text-foreground-800 border border-background-300 px-4 py-2 rounded-md hover:bg-background-200 transition-colors whitespace-nowrap w-fit"
            >
              更多焦点
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-[15px]" />
              </span>
            </a>
          }
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {focusItems.map((item, idx) => (
            <article
              key={item.id}
              className={`group rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col ${
                idx === 0 ? 'md:row-span-1' : ''
              }`}
            >
              <div className="relative w-full h-[220px] md:h-[240px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.category} 追踪`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center bg-foreground-950/80 text-background-50 text-[11px] font-medium px-2.5 py-1 rounded-full backdrop-blur">
                  {item.category}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 bg-accent-500 text-foreground-950 text-[11px] font-semibold px-2.5 py-1 rounded-full">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-fire-line text-[11px]" />
                  </span>
                  {item.heat}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-[17px] md:text-[18px] font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-foreground-600 flex-1">
                  {item.excerpt}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-[12px] text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-chat-3-line text-[13px]" />
                    </span>
                    {item.comments} 讨论
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-calendar-line text-[13px]" />
                    </span>
                    {item.updated}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}